import PropTypes from "prop-types";
import React from "react";
import ReactAutosizeInput from "react-input-autosize";
import { ClassNames } from "@emotion/react";
import { text, sealBlue } from "@govlaunch/palette";

export default function TagsAutosizeInput({ inputStyle: setInputStyle, containerStyle: setContainerStyle, ...props }) {
  return (
    <ClassNames>
      {({ css }) => (
        <ReactAutosizeInput
          spellCheck={false}
          autoComplete="off"
          {...props}
          style={{
            ...containerStyle,
            ...setContainerStyle,
          }}
          inputClassName={css`
            &::placeholder {
              color: ${sealBlue};
            }
          `}
          inputStyle={{
            ...inputStyle,
            ...setInputStyle,
          }}
        />
      )}
    </ClassNames>
  );
}

TagsAutosizeInput.propTypes = {
  inputStyle: PropTypes.object,
  containerStyle: PropTypes.object,
};

TagsAutosizeInput.defaultProps = {
  inputStyle: null,
  containerStyle: null,
};

const containerStyle = {
  display: "inline-flex",
  flex: 1,
  minWidth: 50,
  marginTop: 5,
};

const inputStyle = {
  width: "100%",
  height: "100%",
  minHeight: 25,
  boxSizing: "border-box",
  color: text,
  fontSize: 14,
  fontWeight: 500,
  boxShadow: "none",
  margin: 0,
  padding: "0 0 0 5px",
  outline: 0,
  border: "none",
  backgroundColor: "transparent",
};
